import {
  OperacaoCompraVendaRequest,
  OperacaoCompraVendaResponse,
  OperacaoOfertaPrimariaRequest,
  CommandResult,
  OperacaoOfertaPrimariaResponse,
  AddInteroperabilidadeRequest,
  OperacaoInteroperabilidadeResponse,
  GETOperacoesFilterParams,
  GETComprasVendasFilterParams,
  CompraVendaResumoResponse,
  TransferenciaRequest,
  OperacaoTransferenciaResponse,
  TransferenciaCustodiaResponse,
  TransferenciaCustodiaRequest,
  TransferenciaInteroperabilidadeRequest,
  CommandResultTyped,
  SolicitacaoInteroperabilidadeResult,
  Comprovante,
  ComprovanteInvestidorResponse,
  CancelamentoQuantidadesRequest,
  PaginatedResult,
  TransferenciaResumoResponse,
  GETTransferenciasResumoFilterParams,
  OperacaoCompraVendaCompromissadaResponse,
  OperacaoCompraVendaCompromissadaRequest,
  OperacaoOfertaPrimariaCriarLiquidarRequest,
  TipoLiquidacao,
  ApproveOfertaPrimariaRequest,
  CancelarAlterarAgendamentoRequest,
  AgendamentoMovimentacao,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  aplicarPaginacaoDaListagem,
  ListagemDeMovimentacoes,
  registrarPaginacaoDaListagem,
} from 'utils/paginacaoDaListagemDeMovimentacoes';
import { axiosInstance, request, requestConfig } from './base';

const TIMEOUT_RELATORIO_COMPLETO = 300000;

export const POSTOfertasPrimariasRelatorioCompleto = async (
  dispatch: Dispatch,
  filter?: GETOperacoesFilterParams,
  stackRequest: boolean = false
): Promise<Array<OperacaoOfertaPrimariaResponse>> => {
  const filtroDaExportacao = aplicarPaginacaoDaListagem(ListagemDeMovimentacoes.OFERTAS_PRIMARIAS, filter);

  return await request(
    () =>
      axiosInstance.post<Array<OperacaoOfertaPrimariaResponse>>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias/relatorio-completo`,
        filtroDaExportacao,
        { timeout: TIMEOUT_RELATORIO_COMPLETO }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTComprasVendasRelatorioCompleto = async (
  dispatch: Dispatch,
  filter?: GETComprasVendasFilterParams,
  stackRequest: boolean = false
): Promise<Array<CompraVendaResumoResponse>> => {
  const filtroDaExportacao = aplicarPaginacaoDaListagem(ListagemDeMovimentacoes.COMPRAS_VENDAS, filter);

  return await request(
    () =>
      axiosInstance.post<Array<CompraVendaResumoResponse>>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas/relatorio-completo`,
        filtroDaExportacao,
        { timeout: TIMEOUT_RELATORIO_COMPLETO }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTAnexos = async (dispatch: Dispatch, attachments: Comprovante[], stackRequest: boolean = false) => {
  const formData = new FormData();
  attachments.forEach((attachment, index) => {
    formData.append(`Files[${index}].File`, attachment.file!);
    formData.append(`Files[${index}].InvestidorId`, attachment.investidorId);
  });

  const currentEndpoint = `${requestConfig.api}test/anexos`;
  return await request(
    () =>
      axiosInstance.post(currentEndpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOperacaoOfertaPrimariaDetalhes = async (
  dispatch: Dispatch,
  operacaoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<OperacaoOfertaPrimariaResponse>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias/${operacaoId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTOperacaoOfertaPrimaria = async (
  dispatch: Dispatch,
  instrumentoId: string,
  operacaoOfertaPrimariaRequest: OperacaoOfertaPrimariaRequest,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.post<OperacaoOfertaPrimariaResponse>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/${instrumentoId}/ofertas-primarias`,
        operacaoOfertaPrimariaRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTOperacaoOfertaPrimariaCriarELiquidar = async (
  dispatch: Dispatch,
  operacaoOfertaPrimariaRequest: OperacaoOfertaPrimariaCriarLiquidarRequest,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.post<OperacaoOfertaPrimariaResponse>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/ofertas-primarias/criar-liquidar`,
        operacaoOfertaPrimariaRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOperacaoCompraVendaDetalhes = async (
  dispatch: Dispatch,
  operacaoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<OperacaoCompraVendaResponse>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas/${operacaoId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTOperacaoCompraVenda = async (
  dispatch: Dispatch,
  instrumentoId: string,
  operacoesCompraVendaRequest: Array<OperacaoCompraVendaRequest>,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.post<Array<OperacaoCompraVendaResponse>>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/${instrumentoId}/compras-vendas`,
        operacoesCompraVendaRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTOperacaoCompraCompromissadaVenda = async (
  dispatch: Dispatch,
  instrumentoId: string,
  operacoesCompraVendaCompromissadaRequest: Array<OperacaoCompraVendaCompromissadaRequest>,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.post<Array<OperacaoCompraVendaCompromissadaResponse>>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/${instrumentoId}/compras-vendas-compromissadas`,
        operacoesCompraVendaCompromissadaRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOperacoesInteroperabilidade = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<OperacaoInteroperabilidadeResponse>>(
        `${requestConfig.api}api/v1/operacoes/interoperabilidades`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOperacoesOfertaPrimaria = async (
  dispatch: Dispatch,
  params?: GETOperacoesFilterParams,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.get<Array<OperacaoOfertaPrimariaResponse>>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOperacoesOfertaPrimariaPaginated = async (
  dispatch: Dispatch,
  filter?: GETOperacoesFilterParams,
  stackRequest: boolean = false
): Promise<PaginatedResult<OperacaoOfertaPrimariaResponse>> => {
  const paginaDaListagem = await request(
    () =>
      axiosInstance.post<PaginatedResult<OperacaoOfertaPrimariaResponse>>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias/paginated`,
        filter
      ),
    dispatch,
    undefined,
    stackRequest
  );

  registrarPaginacaoDaListagem(ListagemDeMovimentacoes.OFERTAS_PRIMARIAS, {
    pagina: paginaDaListagem?.page,
    tamanhoDaPagina: paginaDaListagem?.pageSize,
  });

  return paginaDaListagem;
};

export const POSTAprovarOfertaPrimaria = async (
  dispatch: Dispatch,
  operacaoId: string,
  comprovantes?: Comprovante[],
  stackRequest: boolean = true
) => {
  let body: FormData | undefined;
  if (comprovantes) {
    const formData = new FormData();
    comprovantes.forEach((comprovante, index) => {
      formData.append(`comprovantes[${index}].Arquivo`, comprovante.file!);
      formData.append(`comprovantes[${index}].InvestidorId`, comprovante.investidorId);
    });
    body = formData;
  }
  return await request(
    () =>
      axiosInstance.post<OperacaoOfertaPrimariaResponse>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias/${operacaoId}/approve`,
        body,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTComprovanteInvestidorById = async (
  dispatch: Dispatch,
  operacaoId: string,
  investidorId: string,
  files: File[],
  stackRequest: boolean = true
) => {
  return await Promise.all(
    files.map((file) => {
      const formData = new FormData();
      formData.append('Arquivo', file);
      return request(
        () =>
          axiosInstance.post<void>(
            `${requestConfig.api}api/v1/operacoes/ofertas-primarias/${operacaoId}/investidores/${investidorId}/comprovantes`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          ),
        dispatch,
        undefined,
        stackRequest
      );
    })
  );
};

export const GETComprovantesInvestidor = async (
  dispatch: Dispatch,
  operacaoId: string,
  investidorId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<Array<ComprovanteInvestidorResponse>>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias/${operacaoId}/investidores/${investidorId}/comprovantes`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETComprovanteInvestidorDownloadUrl = async (
  dispatch: Dispatch,
  operacaoId: string,
  investidorId: string,
  comprovanteId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<string>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias/${operacaoId}/comprovantes/${comprovanteId}/download`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTReprovarOfertaPrimaria = async (
  dispatch: Dispatch,
  operacaoId: string,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.post<OperacaoOfertaPrimariaResponse>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias/${operacaoId}/reject`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOfertaPrimariaComprovanteDownloadUrl = async (
  dispatch: Dispatch,
  ofertaPrimariaId: string,
  comprovanteId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<string>(
        `${requestConfig.api}api/v1/operacoes/ofertas-primarias/${ofertaPrimariaId}/comprovantes/${comprovanteId}/download`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOperacoesCompraVenda = async (
  dispatch: Dispatch,
  params?: GETOperacoesFilterParams,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.get<Array<OperacaoCompraVendaResponse>>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTComprasVendasPaginated = async (
  dispatch: Dispatch,
  filter?: GETComprasVendasFilterParams,
  stackRequest: boolean = false
): Promise<PaginatedResult<CompraVendaResumoResponse>> => {
  const paginaDaListagem = await request(
    () =>
      axiosInstance.post<PaginatedResult<CompraVendaResumoResponse>>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas/paginated`,
        filter
      ),
    dispatch,
    undefined,
    stackRequest
  );

  registrarPaginacaoDaListagem(ListagemDeMovimentacoes.COMPRAS_VENDAS, {
    pagina: paginaDaListagem?.page,
    tamanhoDaPagina: paginaDaListagem?.pageSize,
  });

  return paginaDaListagem;
};

export const POSTComprasVendasCompromissadasPaginated = async (
  dispatch: Dispatch,
  filter?: GETComprasVendasFilterParams,
  stackRequest: boolean = false
): Promise<PaginatedResult<CompraVendaResumoResponse>> => {
  return await request(
    () =>
      axiosInstance.post<PaginatedResult<CompraVendaResumoResponse>>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas-compromissadas/paginated`,
        filter
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GetOperacoesCompraVendaCompromissada = async (
  dispatch: Dispatch,
  params?: GETOperacoesFilterParams,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.get<Array<OperacaoCompraVendaCompromissadaResponse>>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas-compromissadas`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTAceitarCompraVenda = async (dispatch: Dispatch, operacaoId: string, stackRequest: boolean = true) => {
  return await request(
    () =>
      axiosInstance.post<OperacaoCompraVendaResponse>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas/${operacaoId}/accept`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTRejeitarCompraVenda = async (dispatch: Dispatch, operacaoId: string, justificativa: string, stackRequest: boolean = true) => {
  return await request(
    () =>
      axiosInstance.post<OperacaoCompraVendaResponse>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas/${operacaoId}/reject`,
        { justificativa }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTCancelarCompraVenda = async (dispatch: Dispatch, operacaoId: string, justificativa: string, stackRequest: boolean = true) => {
  return await request(
    () =>
      axiosInstance.post<OperacaoCompraVendaResponse>(
        `${requestConfig.api}api/v1/operacoes/compras-vendas/${operacaoId}/reject`,
        { justificativa }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarLiquidacaoCompraVenda = async (
  dispatch: Dispatch,
  operacaoId: string,
  precoUnitario?: number,
  stackRequest: boolean = true
) => {
  const url = `${requestConfig.api}api/v1/operacoes/compras-vendas/${operacaoId}/confirm`;

  return await request(
    () =>
      precoUnitario === undefined
        ? axiosInstance.post<OperacaoCompraVendaResponse>(url)
        : axiosInstance.post<OperacaoCompraVendaResponse>(url, { precoUnitario }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTOperacoesCompraVenda = async (
  dispatch: Dispatch,
  instrumentoId: string,
  operacaoCompraVendaRequest: Array<OperacaoCompraVendaRequest>,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.post<Array<OperacaoCompraVendaResponse>>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/${instrumentoId}/compras-vendas`,
        operacaoCompraVendaRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTOperacoesTransferencia = async (
  dispatch: Dispatch,
  instrumentoId: string,
  body: TransferenciaRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<OperacaoTransferenciaResponse>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/${instrumentoId}/transferencias`,
        body
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciaCustodia = async (
  dispatch: Dispatch,
  body: TransferenciaCustodiaRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CommandResult>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-custodia/solicitacao-transferencia`,
        body
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTTransferenciaDocument = async (
  dispatch: Dispatch,
  operacaoId: string,
  transferenciaId: string,
  file: File,
  stackRequest: boolean = false
) => {
  const data = new FormData();
  data.append('file', file);
  return await request(
    () =>
      axiosInstance.put(
        `${requestConfig.api}api/v1/operacoes/${operacaoId}/transferencias/${transferenciaId}/document`,
        data,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTTransferenciaCustodiaDocuments = async (
  dispatch: Dispatch,
  transferenciaId: string,
  files: Array<File>,
  stackRequest: boolean = false
) => {
  const formFiles = new FormData();
  files.forEach((file) => formFiles.append('formFiles', file));

  return await request(
    () =>
      axiosInstance.put(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-custodia/solicitacao-transferencia/${transferenciaId}/document`,
        formFiles,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOperacoesTransferencia = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<OperacaoTransferenciaResponse>>(`${requestConfig.api}api/v1/operacoes/transferencias`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciasResumoPaginated = async (
  dispatch: Dispatch,
  filter?: GETTransferenciasResumoFilterParams,
  stackRequest: boolean = false
): Promise<PaginatedResult<TransferenciaResumoResponse>> => {
  return await request(
    () =>
      axiosInstance.post<PaginatedResult<TransferenciaResumoResponse>>(
        `${requestConfig.api}api/v1/transferencias/resumo`,
        filter
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETOperacaoTransferencia = async (
  dispatch: Dispatch,
  transferenciaId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<OperacaoTransferenciaResponse>(
        `${requestConfig.api}api/v1/transferencias/${transferenciaId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};







export const POSTTransferenciaInteroperabilidadeEntrada = async (
  dispatch: Dispatch,
  body: AddInteroperabilidadeRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CommandResult>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-interoperabilidade/comandar-entrada`,
        body
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciaInteroperabilidadeSaida = async (
  dispatch: Dispatch,
  body: AddInteroperabilidadeRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CommandResult>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-interoperabilidade/comandar-saida`,
        body
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciaInteroperabilidade = async (
  dispatch: Dispatch,
  body: TransferenciaInteroperabilidadeRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CommandResultTyped<SolicitacaoInteroperabilidadeResult>>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-interoperabilidade/solicitacao`,
        body
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTTransferenciaInteroperabilidadeDocuments = async (
  dispatch: Dispatch,
  transferenciaId: string,
  files: Array<File>,
  stackRequest: boolean = false
) => {
  const formFiles = new FormData();
  files.forEach((file) => formFiles.append('formFiles', file));

  return await request(
    () =>
      axiosInstance.put(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-interoperabilidade/${transferenciaId}/document`,
        formFiles,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETInteroperabilidadeDocumentDownloadUrl = async (
  dispatch: Dispatch,
  interoperabilidadeId: string,
  documentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<{ data: string }>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-interoperabilidade/${interoperabilidadeId}/document/${documentId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAprovarTransferenciaInteroperabilidade = async (
  dispatch: Dispatch,
  interoperabilidadeId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<any>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-interoperabilidade/${interoperabilidadeId}/approve`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTRecusarTransferenciaInteroperabilidade = async (
  dispatch: Dispatch,
  interoperabilidadeId: string,
  justificativa: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<any>(
        `${requestConfig.api}api/v1/instrumentos-financeiros/transferencias-interoperabilidade/${interoperabilidadeId}/reject`,
        undefined,
        {
          params: { justificativa },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTCancelarQuantidades = async (
  dispatch: Dispatch,
  body: CancelamentoQuantidadesRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () => axiosInstance.post(`${requestConfig.api}api/v1/operacoes/cancelamento`, body),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTLiquidarOfertaPrimaria = async (
  dispatch: Dispatch,
  operacaoId: string,
  body: ApproveOfertaPrimariaRequest,
  stackRequest: boolean = true
): Promise<OperacaoOfertaPrimariaResponse> =>
  await request(
    () =>
      axiosInstance.post<OperacaoOfertaPrimariaResponse>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/ofertas-primarias/${operacaoId}/aprovar-liquidar?tipoLiquidacao=${body.tipoLiquidacao}&custodianteId=${body.custodianteId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );

export const PUTAgendamentoOfertaPrimaria = async (
  dispatch: Dispatch,
  body: CancelarAlterarAgendamentoRequest,
  stackRequest: boolean = true
): Promise<OperacaoOfertaPrimariaResponse> =>
  await request(
    () =>
      axiosInstance.put<OperacaoOfertaPrimariaResponse>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/${body.operacaoId}/agendamentos`,
        body
      ),
    dispatch,
    undefined,
    stackRequest
  );

export const GETAgendamentosOfertaPrimaria = async (
  dispatch: Dispatch,
  operacaoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<Array<AgendamentoMovimentacao>>(
        `${requestConfig.api}api/v1/operacoes/instrumentos-financeiros/${operacaoId}/agendamentos`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETInvestidoresVenda = async (dispatch: Dispatch, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<import('common/genericTypes').InvestidorVendaResponse>>(
        `${requestConfig.api}api/v1/operacoes/investidores`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETEmissorVenda = async (dispatch: Dispatch, cnpjEmissor: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<import('common/genericTypes').EmissorVendaResponse>(
        `${requestConfig.api}api/v1/operacoes/emissores/${cnpjEmissor}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCustodianteVenda = async (dispatch: Dispatch, cnpj: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<import('common/genericTypes').CustodianteVendaResponse>(
        `${requestConfig.api}api/v1/operacoes/custodiantes/${cnpj}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETInvestidorDestinoVenda = async (dispatch: Dispatch, cpfCnpj: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<import('common/genericTypes').InvestidorDestinoVendaResponse>(
        `${requestConfig.api}api/v1/operacoes/investidores/${cpfCnpj}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETInvestidoresCustodiante = async (dispatch: Dispatch, cnpj: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<import('common/genericTypes').InvestidorCustodianteResponse>>(
        `${requestConfig.api}api/v1/transferencias/custodiantes/${cnpj}/investidores`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCustodiantesInvestidor = async (dispatch: Dispatch, cpfCnpj: string, stackRequest: boolean = false) => {
  return await request(
    () =>
      axiosInstance.get<Array<import('common/genericTypes').CustodianteInvestidorResponse>>(
        `${requestConfig.api}api/v1/transferencias/investidores/${cpfCnpj}/custodiantes`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciaCustodiaLote = async (
  dispatch: Dispatch,
  payload: import('common/genericTypes').TransferenciaCustodiaLoteRequest,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.post<import('common/genericTypes').TransferenciaLoteResponse>(
        `${requestConfig.api}api/v1/transferencias/custodia`,
        payload
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciaTitularidadeLote = async (
  dispatch: Dispatch,
  payload: import('common/genericTypes').TransferenciaTitularidadeLoteRequest,
  stackRequest: boolean = true
) => {
  return await request(
    () =>
      axiosInstance.post<import('common/genericTypes').TransferenciaLoteResponse>(
        `${requestConfig.api}api/v1/transferencias/titularidade`,
        payload
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciaDocumentosLote = async (
  dispatch: Dispatch,
  operacaoIds: string[],
  arquivos: File[],
  stackRequest: boolean = true
) => {
  const formData = new FormData();
  let index = 0;
  for (const operacaoId of operacaoIds) {
    for (const arquivo of arquivos) {
      formData.append(`Itens[${index}].OperacaoId`, operacaoId);
      formData.append(`Itens[${index}].Arquivo`, arquivo);
      index++;
    }
  }
  return await request(
    () =>
      axiosInstance.post<import('common/genericTypes').TransferenciaDocumentoLoteResponse>(
        `${requestConfig.api}api/v1/transferencias/documentos-lote`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

// SR-890: busca instrumentos financeiros disponíveis para venda pelo CPF/CNPJ do investidor
export const GETInstrumentosInvestidorVenda = async (
  dispatch: Dispatch,
  cpfCnpj: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<
        | Array<import('common/genericTypes').InvestidorInstrumentoVendaResponse>
        | { instrumentos: Array<import('common/genericTypes').InvestidorInstrumentoVendaResponse> }
      >(
        `${requestConfig.api}api/v1/operacoes/investidores/${cpfCnpj}/instrumentos`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTVendaLote = async (
  dispatch: Dispatch,
  payload: Array<import('common/genericTypes').VendaLoteItemRequest>,
  stackRequest: boolean = true
) => {
  return await request(
    () => axiosInstance.post(`${requestConfig.api}api/v1/operacoes/vendas-lote`, payload),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTVendaLoteComprovantes = async (
  dispatch: Dispatch,
  itens: Array<{ operacaoId: string; arquivo: File }>,
  stackRequest: boolean = true
) => {
  const formData = new FormData();
  itens.forEach((item, index) => {
    formData.append(`Itens[${index}].OperacaoId`, item.operacaoId);
    formData.append(`Itens[${index}].Arquivo`, item.arquivo);
  });

  return await request(
    () =>
      axiosInstance.post(`${requestConfig.api}api/v1/operacoes/vendas-lote/comprovantes`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCompraVendaDocumentos = async (
  dispatch: Dispatch,
  operacaoId: string,
  stackRequest: boolean = false
): Promise<Array<import('common/genericTypes').CompraVendaDocumento>> => {
  return await request(
    () =>
      axiosInstance.get<Array<import('common/genericTypes').CompraVendaDocumento>>(
        `${requestConfig.api}api/v1/operacoes/vendas-lote/${operacaoId}/comprovantes`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTUploadCompraVendaDocumento = async (
  dispatch: Dispatch,
  operacaoId: string,
  arquivo: File,
  stackRequest: boolean = false
) => {
  const formData = new FormData();
  formData.append('Itens[0].OperacaoId', operacaoId);
  formData.append('Itens[0].Arquivo', arquivo);

  return await request(
    () =>
      axiosInstance.post(`${requestConfig.api}api/v1/operacoes/vendas-lote/comprovantes`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export interface AprovacaoLoteItem {
  operacaoId: string;
  codigoIF: string;
  sucesso: boolean;
  mensagemErro: string | null;
}

export interface AprovacaoLoteResponse {
  status: 'SUCESSO' | 'PARCIAL' | 'FALHA';
  mensagem: string;
  resumo: {
    totalProcessados: number;
    totalSucesso: number;
    totalFalha: number;
  };
  itens: AprovacaoLoteItem[];
}

export const POSTAprovacaoCompraVendaEmLote = async (
  dispatch: Dispatch,
  operacaoIds: string[],
  stackRequest: boolean = true
): Promise<AprovacaoLoteResponse> => {
  return await request(
    () =>
      axiosInstance.post(`${requestConfig.api}api/v1/operacoes/vendas-lote/aprovacao-lote`, {
        operacaoIds,
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTAprovacaoTransferenciaEmLote = async (
  dispatch: Dispatch,
  operacaoIds: string[],
  stackRequest: boolean = true
): Promise<AprovacaoLoteResponse> => {
  return await request(
    () =>
      axiosInstance.post(`${requestConfig.api}api/v1/transferencias/aprovacao-lote`, {
        operacaoIds,
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTReprovacaoTransferenciaEmLote = async (
  dispatch: Dispatch,
  operacaoIds: string[],
  justificativa: string,
  stackRequest: boolean = true
): Promise<AprovacaoLoteResponse> => {
  return await request(
    () =>
      axiosInstance.post(`${requestConfig.api}api/v1/transferencias/reprovacao-lote`, {
        operacaoIds,
        justificativa,
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciaLoteComprovantes = async (
  dispatch: Dispatch,
  itens: Array<{ operacaoId: string; arquivo: File }>,
  stackRequest: boolean = true
) => {
  const formData = new FormData();
  itens.forEach((item, index) => {
    formData.append(`Itens[${index}].OperacaoId`, item.operacaoId);
    formData.append(`Itens[${index}].Arquivo`, item.arquivo);
  });

  return await request(
    () =>
      axiosInstance.post(`${requestConfig.api}api/v1/transferencias/documentos-lote`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export interface TransferenciaDocumento {
  id: string;
  fileName: string;
  extension: string;
  size: number;
  url: string;
  operacaoId: string;
  creationDate: string;
}

export const GETTransferenciaDocumentos = async (
  dispatch: Dispatch,
  operacaoId: string,
  stackRequest: boolean = false
): Promise<Array<import('common/genericTypes').CompraVendaDocumento>> => {
  return await request(
    () =>
      axiosInstance.get<Array<import('common/genericTypes').CompraVendaDocumento>>(
        `${requestConfig.api}api/v1/transferencias/${operacaoId}/documentos`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

// === Novos endpoints de criação de transferência (SR-961) ===

export interface TransferenciaCustodiaNovaRequest {
  investidorOrigemCpfCnpj: string;
  custodianteOrigemCnpj: string;
  custodianteDestinoCnpj: string;
  instrumentosFinanceiros: Array<{ codigo: string; quantidade: number }>;
  motivo: string;
  justificativa: string;
}

export interface TransferenciaTitularidadeNovaRequest {
  investidorOrigemCpfCnpj: string;
  custodianteOrigemCnpj: string;
  instrumentosFinanceiros: Array<{
    codigo: string;
    destinos: Array<{
      custodianteDestinoCnpj: string | null;
      investidorDestinoCpfCnpj: string;
      quantidade: number;
    }>;
  }>;
  motivo: string;
  justificativa: string;
}

export interface TransferenciaLoteResponse {
  status: 'SUCESSO' | 'PARCIAL' | 'FALHA';
  mensagem: string;
  resumo: {
    totalProcessados: number;
    totalSucesso: number;
    totalPendente: number;
    totalConcluido: number;
    totalFalha: number;
  };
  itens: Array<{
    codigoIF: string;
    custodianteDestinoCnpj: string | null;
    investidorDestinoCpfCnpj: string;
    quantidade: number;
    operacaoId: string;
    sucesso: boolean;
    status: string;
    mensagemErro: string | null;
  }>;
}

export const POSTTransferenciaCustodiaNova = async (
  dispatch: Dispatch,
  body: TransferenciaCustodiaNovaRequest,
  stackRequest: boolean = false
): Promise<TransferenciaLoteResponse> => {
  return await request(
    () =>
      axiosInstance.post<TransferenciaLoteResponse>(
        `${requestConfig.api}api/v1/transferencias/custodia`,
        body
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTTransferenciaTitularidadeNova = async (
  dispatch: Dispatch,
  body: TransferenciaTitularidadeNovaRequest,
  stackRequest: boolean = false
): Promise<TransferenciaLoteResponse> => {
  return await request(
    () =>
      axiosInstance.post<TransferenciaLoteResponse>(
        `${requestConfig.api}api/v1/transferencias/titularidade`,
        body
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

// === Endpoint leve de instrumentos financeiros para autocomplete de transferências ===

export interface InstrumentoFinanceiroResumoTransferencia {
  instrumentoFinanceiroGuid: string;
  codigo: string;
  razaoSocialEmissor: string;
  numeroEmissao: string;
  tipoInstrumentoFinanceiro: string;
  dataEmissao: string | null;
  volumeEmissao: number | null;
}

export interface PaginatedInstrumentoFinanceiroResumo {
  result: Array<InstrumentoFinanceiroResumoTransferencia>;
  page: number;
  pageSize: number;
  totalCount: number;
}

export const GETInstrumentosFinanceirosTransferencia = async (
  dispatch: Dispatch,
  search: string = '',
  page: number = 1,
  pageSize: number = 20,
  stackRequest: boolean = false
): Promise<PaginatedInstrumentoFinanceiroResumo> => {
  return await request(
    () =>
      axiosInstance.get<PaginatedInstrumentoFinanceiroResumo>(
        `${requestConfig.api}api/v1/transferencias/instrumentos-financeiros`,
        { params: { search: search || undefined, page, pageSize } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETInstrumentoInadimplencia = async (
  dispatch: Dispatch,
  instrumentoFinanceiroGuid: string,
  stackRequest: boolean = false
): Promise<{ hasPagamentosInadimplentes: boolean }> => {
  return await request(
    () =>
      axiosInstance.get<{ hasPagamentosInadimplentes: boolean }>(
        `${requestConfig.api}api/v1/transferencias/instrumentos-financeiros/${instrumentoFinanceiroGuid}/inadimplencia`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};
